import baseFetch, { createParamString } from '../baseFetch';

// eslint-disable-next-line import/prefer-default-export
export const fetchEditorialArticleById = (id, preview, cookies) => {
  const opts = {};
  let url = `/wp-json/sl/v1/posts?${createParamString({ id })}`;
  if (preview) {
    opts.credentials = 'include';
    url += `&${createParamString({ preview: true, uuid: Date.now() })}`;
  }
  return baseFetch(url, opts, { cookies });
};

export const fetchEditorialTaxonomyDetails = (taxonomy, term, subCategory) => {
  const opts = {};
  let url = `/wp-json/sl/v1/taxonomy/details/${taxonomy}`;
  if (term) url += `/${term}`;
  if (subCategory) url += `/${subCategory}`;
  return baseFetch(url, opts);
};

export const fetchEditorialTaxonomyPosts = (taxonomy, term, subCategory, limit, offset) => {
  const opts = {};
  let url = `/wp-json/sl/v1/taxonomy/posts/${taxonomy}`;
  if (term) url += `/${term}`;
  if (subCategory) url += `/${subCategory}`;
  return baseFetch(`${url}?${createParamString({ limit, offset })}`, opts);
};
